import React from 'react';
import EyeIcon from 'src/common/utils/TableColumnIcons/EyeIcon';

export const ActionColumnFormat = (value, row, rowIndex, { onEye }) => {
	return (
		<>
			<EyeIcon onClick={() => onEye(row)} color="primary" />
		</>
	);
};
